module.exports = __webpack_public_path__ + "media/images/WFC_Award_White_w_0-8ecae2824e53e04fa0b6290d7aec612f.svg";